export default {
  regular: {
    phone: /^1[34578]\d{9}$/,
    // email: /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/,
    email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
    qq: /^[1-9][0-9]{4,14}$/,
    number: /^[0-9]*$/
  },
  searchTime: 1000,
  // 链接
  apiURL: 'https://api.qa.chintec.net/'
  // adminUrl: '',
  // mobileUrl: ''
  // 测试
  // //链接
  // apiURL: 'http://test.api.qa.chintec.net/',
  // adminUrl: '',
  // mobileUrl: ''
}





// WEBPACK FOOTER //
// ./src/common/js/getConfig.js